import React from 'react';
import { mapModifiers } from 'libs/component';
import { motion } from 'framer-motion';

export interface LayoutProps {
  children?: React.ReactNode;
  pageId: string;
}

// const variants = {
//   hidden: { opacity: 0, x: 0, y: 0 },
//   enter: { opacity: 1, x: 0, y: 0 },
//   exit: { opacity: 0, x: 0, y: 0 },
// };

export const Layout: React.FC<LayoutProps> = ({ children, pageId }) => (
  <div key={pageId} className={mapModifiers('t-layout')}>
    <motion.main
      className="t-layout__main"
      // initial="hidden"
      // animate="enter"
      // exit="exit"
      // variants={variants}
      // transition={{ type: 'linear' }}
    >
      {children}
    </motion.main>
  </div>
);
